import { h, render, Fragment } from 'preact';
import { useContext } from 'preact/hooks';
import { Products } from '../context/Product';
import { ProductListWrap } from '../product-list-wrap/product-list-wrap';
import { ProductCard } from '../product-card/product-card';
import { Cta } from '../common/Cta';

export interface ProductListWindow extends Window {
  isLoggedIn: boolean;
}

declare let window: ProductListWindow;

const LoaderCard = () => <div class="product-card-loader"> </div>;

const ProductListContent = () => {
  const { loading, products, loadingMore, results } = useContext(Products);

  return (
    <Fragment>
      <div class="product-card-grid">
        {(!loading || (loadingMore && loading)) &&
          products &&
          products?.length >= 1 &&
          products.map((item, index) => <ProductCard key={`${item.id}-${index}`} product={item} />)}
        {loading && [...Array(4)].map((_, index) => <LoaderCard key={`loader${index}`} />)}
      </div>

      {results.page >= results.total_pages && (
        <div className="band" data-test="seasonal-message">
          <div className="band__content">
            <Cta
              heading="Can't find what you're looking for?"
              subHeading="Find the full list of the products you have previously ordered."
              url="/account-dashboard/my-products"
              urlLabel="My products"
            />
          </div>
        </div>
      )}
    </Fragment>
  );
};

const SeasonalProducts = ({ categoryId, showCategories, order, pagination, alwaysShowFilters }) => (
  <Fragment>
    <ProductListWrap
      categoryId={categoryId}
      order={order}
      pagination={pagination}
      showCategories={showCategories}
      api="productSeasonal"
      filterButtonLabel="Filters"
      hideFilterDropDown
      showAllButton={false}
      data-test="seasonal-products"
      alwaysShowFilters={alwaysShowFilters}
    >
      <ProductListContent />
    </ProductListWrap>
  </Fragment>
);

try {
  const domContainer = document.querySelector('#seasonal-products');

  if (domContainer) {
    // Get the root element to render the component if the DOM contains the ID element
    const seasonalProductsInner = domContainer.querySelector('.seasonal-products');
    const alwaysShowFilters = !!domContainer.getAttribute('data-force-filters');
    const categoryId = domContainer.getAttribute('data-category');
    const order = 'alphabeticallyAscending';
    const pagination = 4;

    // Render the component within the app
    render(
      <SeasonalProducts
        categoryId={categoryId ? categoryId : ''}
        order={order}
        pagination={pagination}
        showCategories
        alwaysShowFilters={alwaysShowFilters}
      />,
      domContainer,
      seasonalProductsInner
    );
  }
} catch (e) {
  console.warn(e);
}
